// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__2VtRO","blue":"Chip_blue__1wjcx","green":"Chip_green__1YAfO","red":"Chip_red__2jvHN"};